import type { EChartsTheme } from '../types';

type AgeAxisOptions = {
  theme: EChartsTheme;
  title: string;
  min: number;
  max: number;
};

// Numeric x-axis rendering ages as whole numbers. Shared by the RetirementChart projection and
// its zero-state placeholder so both use the same axis styling and title.
export const buildAgeXAxis = ({ theme, title, min, max }: AgeAxisOptions) => ({
  type: 'value' as const,
  name: title,
  nameLocation: 'middle' as const,
  nameGap: 28,
  nameTextStyle: { color: theme.textColor, fontFamily: theme.fontFamily, fontSize: 14, fontWeight: 500 },
  min,
  max,
  minInterval: 1,
  axisLabel: { color: theme.textTertiaryColor, formatter: (val: number) => String(Math.round(val)) },
  axisLine: { lineStyle: { color: theme.dividerColor } },
  axisTick: { show: false },
  splitLine: { show: true, lineStyle: { color: theme.gridColor } },
});
